<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
            <v-btn fab  dark large color="brown darken-4" fixed right bottom><v-icon>person_add</v-icon></v-btn>
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>ADD NEW MOVIE</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
             <h6>   
              Note: The unique ID for this movie will be the 
              name of the movie which has been stripped 
              of spaces. 
             </h6>
             </v-card-text>
             <v-card-text>
                <v-form class="px-3" ref="form"> 
                     <v-text-field label="Movie Name*" v-model="name" :rules="nameRules" prepend-icon="comment"></v-text-field>
                     <v-text-field label="Link Address*" v-model="link" prepend-icon="web" :rules="nameRules"></v-text-field>
                     <v-textarea label="Description" v-model="desc" :rules="descRules" prepend-icon="edit"></v-textarea>
                    
                     <v-icon>file_upload</v-icon> <span class="flex"><b>   Select Image File  </b> <input type="file" class="file"/></span>
                     <br/><span v-if="fileerror" class="red--text">You must select a file</span>
              
                     <span> * indicates required field </span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled">Add Movie</v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
   </span>
</template>

<script>
import {addModuleWithAttachment} from '@/model';
import {trim} from '@/validator';
import moment from 'moment';

export default {
    name: 'AddWatch',
    data() {
        return {
         isDisabled:false,
         desc:'',
         name:'',
         link:'',
         fileerror:false,
         nameRules:[
               v => v.length >=2  || "Minimum length is 3 characters",
               v => v.length <=30  || "Maximum length is 60 characters" 
           ],
        descRules:[
               v => v.length >=15  || "Minimum length is 15 characters",
               v => v.length <=200  || "Maximum length is 200 characters" 
           ]

        };
    },
    methods: {
        add() {
          let self=this;
            if(this.$refs.form.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            let input = document.querySelector('.file');
            
            let file = input.files[0];
            console.log(input.files);
            if(file){
                this.fileerror = false;
                
            }else{
                console.log("Choi")
                this.fileerror = true
                return;
            }
            let useradd = this.$store.getters.getStaff.name;
            let movName = this.name;
            var trimmed = trim(movName);
            let newitem = {name:trimmed,movName:movName,link:this.link,desc:this.desc,file:file.type,dateadded:datenow,useradd:useradd};
          
           self.isDisabled = true;
            
              addModuleWithAttachment('watch','watch now section ',trimmed.toLowerCase(),newitem,file,function(response){
                  if(response){
                      console.log("This is response: ",response);
                      alert('It has been succesfully added to your watch now');
                      self.$store.dispatch('updateWatch',true);
                      self.isDisabled = false;
                  }else{
                      console.log(null);
                      self.isDisabled = false;
                  }

               })
            }
        }
    }
};
</script>

<style scoped>
</style>